import React from 'react'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Alert from '../../components/Alert/Alert'
import { useUpdateUserPasswordMutation } from '../../redux/features/profileSlice';

const errorMsg = 'make sure to write the current password correctly, and new password matched with the confirm password'

function OrganizationUpdatePassword() {

  const navigate = useNavigate()

  const [updateUserPassword, { isLoading }] = useUpdateUserPasswordMutation();

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const [isError, setIsError] = useState(false);
  const [inputCoverd, setInputCoverd] = useState({
    currentPassword:true,
    newPassword:true,
    newPassword2:true,
  });

  const handleCoverPassword = (name) => {
    setInputCoverd((prev)=> ({
      ...prev,
      [name]:!prev[name]
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    let passwordObj = {
      current_password:currentPassword,
      new_password:newPassword,
      new_password2:newPassword2
    }
    if (newPassword===newPassword2) {
      if (isError) setIsError(false)
      console.log(passwordObj)
      try {
        await updateUserPassword(passwordObj).unwrap()
        navigate('/')
  
      } catch (err) {
          console.error('Failed to save the changes', err)
          setIsError(true)
      }
    } else {
      setIsError(true)
    }
  }

  return (
    <div class="col-xl-9">
      <div class="card border bg-transparent rounded-3">
          {/* <!-- Card header --> */}
          <div class="card-header bg-transparent border-bottom">
            <h3 class="card-header-title mb-0">تغيير كلمة المرور</h3>
          </div>
          {/* <!-- Card body START --> */}
          {isError ? <Alert type='error' text={errorMsg}/> : null }
          <form class="card-body row g-4" onSubmit={handleSubmit}>
            {/* <!-- Current password --> */}
            <div class="col-md-6">
              <label class="form-label">كلمة المرور الحالية</label>
              <div class="input-group">
                  <input 
                    class="form-control" 
                    type={inputCoverd.currentPassword ? "password" : "text"} 
                    placeholder="كلمة المرور الحالية"
                    value={currentPassword}
                    onChange={(e)=>setCurrentPassword(e.target.value)}
                    />
                  <span role="button" class="input-group-text p-0 bg-transparent" onClick={()=>handleCoverPassword('currentPassword')}>
                    <i class="far fa-eye cursor-pointer p-2 w-40px"></i>
                  </span>
                </div>
            </div>
            <div class='col-md-6'>
              {/* <!-- New password --> */}
              <div class="mb-3">
                <label class="form-label">كلمة المرور الجديدة</label>
                <div class="input-group">
                  <input 
                    class="form-control" 
                    type={inputCoverd.newPassword ? "password" : "text"} 
                    placeholder="كلمة المرور الجديدة"
                    value={newPassword}
                    onChange={(e)=>setNewPassword(e.target.value)}
                    />
                  <span role="button" class="input-group-text p-0 bg-transparent" onClick={()=>handleCoverPassword('newPassword')}>
                    <i class="far fa-eye cursor-pointer p-2 w-40px"></i>
                  </span>
                </div>
                <div class="rounded mt-1" id="psw-strength"></div>
              </div>
              {/* <!-- Confirm password --> */}
              <div>
                <label class="form-label">تأكيد كلمة المرور الجديدة</label>
                <div class="input-group">
                  <input 
                    class="form-control" 
                    type={inputCoverd.newPassword2 ? "password" : "text"} 
                    placeholder="تأكيد كلمة المرور الجديدة"
                    value={newPassword2}
                    onChange={(e)=>setNewPassword2(e.target.value)}
                    />
                  <span role="button" class="input-group-text p-0 bg-transparent" onClick={()=>handleCoverPassword('newPassword2')}>
                    <i class="far fa-eye cursor-pointer p-2 w-40px"></i>
                  </span>
                </div>
              </div>

            </div>
            
            {/* <!-- Button --> */}
            <div class="d-flex justify-content-end">
              {isLoading ?
                <button class="btn btn-primary" type="button" disabled>
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  يتم التحميل...
                </button> 
              :
              <button type="submit" class="btn btn-primary mb-0">حفظ التغيير</button>
              }
            </div>
           
          </form>
          {/* <!-- Card body END --> */}
        </div>
    </div>
  )
}

export default OrganizationUpdatePassword